import { render } from "./Claim1_Adm.vue?vue&type=template&id=5bb5b7af&scoped=true"
import script from "./Claim1_Adm.vue?vue&type=script&lang=js"
export * from "./Claim1_Adm.vue?vue&type=script&lang=js"

import "./Claim1_Adm.vue?vue&type=style&index=0&id=5bb5b7af&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5bb5b7af"

export default script